import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  get,
  noop,
} from 'lodash';
import {
  compose,
  setDisplayName,
} from 'recompose';
import OutsideClickHandler from 'react-outside-click-handler';
import TextField from '@material-ui/core/TextField';

import { DropdownItems, injectIntl } from 'components';
import immutableToJS from 'helpers/immutableToJS';
import {
  includesSearchText,
} from 'helpers/utils';
import contactsActions from 'redux/contacts/actions';
import { selectState } from 'redux/selectors';

export class AutoFill extends Component {
  static propTypes = {
    contacts: PropTypes.arrayOf(PropTypes.shape({})),
    contactsRequesting: PropTypes.bool,
    formatMessage: PropTypes.func.isRequired,
    listContacts: PropTypes.func.isRequired,
    disabled: PropTypes.bool,

    onSelect: PropTypes.func,
  };

  static defaultProps = {
    contacts: [],
    contactsRequesting: false,
    disabled: false,
    onSelect: noop,
  };

  state = {
    searchText: '',
    showItems: false,
  };

  componentWillMount() {
    const { listContacts } = this.props;
    listContacts();
  }

  getFilteredContacts = () => {
    const { searchText } = this.state;
    const { contacts } = this.props;

    return contacts.filter(c => !(c.requestorId || c.isDeleted) && includesSearchText(
      searchText,
      [
        get(c, 'profile.email'),
        get(c, 'profile.companyName'),
      ],
    ));
  };

  getOptions = () => {
    const { showItems } = this.state;
    const filteredContacts = this.getFilteredContacts();

    if (!showItems) {
      return [];
    }

    return filteredContacts.map(item => ({
      id: item.id,
      primaryText: this.contactItemRenderer(item),
      onClick: () => this.handleSelect(item),
    }));
  }

  contactItemRenderer = contact => (
    <div className="accounts">
      <div className="item-company-email">
        <div>
          {get(contact, 'profile.companyName')}
        </div>
        <div className="item-email">
          {get(contact, 'profile.email')}
        </div>
      </div>
    </div>
  );

  handleBlur = () => {
    setTimeout(() => {
      this.setState({ showItems: false });
    }, 500);
  }

  handleFocus = () => {
    this.setState({ showItems: true });
  }

  handleSearchTextChange = (searchText) => {
    this.setState({ searchText });
  };

  handleSelect = (item) => {
    const { onSelect } = this.props;

    onSelect(item);
    this.setState({
      searchText: get(item, 'profile.companyName'),
      showItems: false,
    });
  }

  render() {
    const {
      contactsRequesting,
      disabled,
      formatMessage,
    } = this.props;
    const { searchText } = this.state;

    const searchedItems = !disabled && (
      <DropdownItems
        loading={contactsRequesting}
        absolute
        options={this.getOptions()}
      />
    );

    return (
      <div className="auto-fill">
        <OutsideClickHandler onOutsideClick={this.handleBlur}>
          <TextField
            autoComplete="off"
            fullWidth
            label={formatMessage('Contact')}
            onChange={ev => this.handleSearchTextChange(ev.target.value)}
            onClick={this.handleFocus}
            onFocus={this.handleFocus}
            placeholder={formatMessage('Search Email or Business name')}
            value={searchText}
            variant="outlined"
            disabled={disabled}
          />
          {searchedItems}
        </OutsideClickHandler>
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('contacts', 'contacts')(state),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  listContacts: payload => dispatch(contactsActions.list(payload)),
});

export default compose(
  setDisplayName('AutoFill'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  immutableToJS,
  injectIntl,
)(AutoFill);
